import { render, staticRenderFns } from "./userTheLayout.vue?vue&type=template&id=13882804&scoped=true&"
import script from "./userTheLayout.vue?vue&type=script&lang=js&"
export * from "./userTheLayout.vue?vue&type=script&lang=js&"
import style0 from "./userTheLayout.vue?vue&type=style&index=0&id=13882804&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13882804",
  null
  
)

export default component.exports